export default "__VITE_ASSET__bf0b7039__"